<template>
    <ul class="sidebarChallenges">
        <h2>{{content.firstPart.mainTitle}}</h2>
        <li v-for="menu in content.firstPart.buttons" :key="menu.text">
            <router-link class="bt btn-browse" :to="{ name: 'challengesHome'}" v-if="!isMobile">
            <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
            </span>
                {{menu.text}}
            </router-link>
            <button class="bt btn-browse"  @click="openAllChallenges" v-else>
            <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
            </span>
                {{menu.text}}
            </button>
        </li>
        <div class="sep"></div>
        <div class="title">
            <h2>{{content.secondPart.mainTitle}}</h2>

            <div v-if="target && target == 'progress'" class="target green">
                {{content.secondPart.etiquette}}
            </div>

            <div v-if="target && target == 'done'" class="target red">
                Terminé
            </div>

        </div>


        <div class="select__wrapper">
            <CustomSelect
                    :options="options"
                    :default="optionsDefault"
                    class="select"
                    @input="displayToKey($event)"
            />
        </div>

        <div v-if="currentType == 'CONFIG_AGENT' || currentType == 'CONFIG_COLLABORATEUR'">
            <li v-for="(menu,index) in content.secondPart.buttonsAgent" :key="menu.text" >
                <b-button class="bt btn-icon" :to="menu.link" v-if="!mobile">
                    <div class="left">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
                        <p> {{menu.text}}</p>
                    </div>
                    <div class="target" v-if="menu.notifications" :class="{hide:notifications==0}">{{notifications}}</div>
                </b-button>

                <b-button class="bt btn-icon" @click="onItemClick(index)" v-else>
                    <div class="left">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
                        <p> {{menu.text}}</p>
                    </div>
                    <div class="target" v-if="menu.notifications" :class="{hide:notifications==0}">{{notifications}}</div>
                </b-button>
            </li>
        </div>
        <div v-else-if="currentType == 'CONFIG_NATIONAL'">
            <li v-for="(menu,index) in content.secondPart.buttonsNational" :key="menu.text" >
                <b-button class="bt btn-icon" :to="menu.link" v-if="!mobile">
                    <div class="left">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
                        <p> {{menu.text}}</p>
                    </div>
                    <div class="target" v-if="menu.notifications" :class="{hide:notifications==0}">{{notifications}}</div>
                </b-button>

                <b-button class="bt btn-icon" @click="onItemClick(index)" v-else>
                    <div class="left">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
                        <p> {{menu.text}}</p>
                    </div>
                    <div class="target" v-if="menu.notifications" :class="{hide:notifications==0}">{{notifications}}</div>
                </b-button>
            </li>
        </div>
        <div v-else>
            <li v-for="(menu,index) in content.secondPart.buttons" :key="menu.text" >
                <b-button class="bt btn-icon" :to="menu.link" v-if="!mobile">
                    <div class="left">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
                        <p> {{menu.text}}</p>
                    </div>
                    <div class="target" v-if="menu.notifications" :class="{hide:notifications==0}">{{notifications}}</div>
                </b-button>

                <b-button class="bt btn-icon" @click="onItemClick(index)" v-else>
                    <div class="left">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
                        <p> {{menu.text}}</p>
                    </div>
                    <div class="target" v-if="menu.notifications" :class="{hide:notifications==0}">{{notifications}}</div>
                </b-button>
            </li>
        </div>
        <br><br>

        <li v-for="menu in content.threePart.buttons" :key="menu.text" >
          <div>
            <a :href="theLawLink" target="_blank" class="bt btn-red"  v-if="currentType === 'CONFIG_AGENT' && theLawLink">
                <span>
                    <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
                </span>
              {{menu.text}}
            </a>
            <b-button @click="openReglementModal()" class="bt btn-red" ref="btnShow" v-else-if="!isMobile">
                  <span>
                      <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
                  </span>
              Les règlements
            </b-button>
          </div>
        </li>

        <div class="mobile">
            <Stack height="5rem"></Stack>
        </div>
    </ul>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Stack from '../stack/Stack';
    import CustomSelect from '../select/CustomSelect';
    import ApiService from '../../../services/ApiService';
    import ApiAuthenticationService from '../../../services/ApiAuthenticationService'

    export default {
        name: "SidebarChallenges",

        components: {
            Stack,
            CustomSelect
        },
        props:{
            mobile: {
                type: Boolean,
                required: false,
            },
        },
        data() {
            return {
                isMobile:false,
                content:{},
                general:{},
                selected: null,
                lists:[],
                options: [],
                optionsDefault:'',
                theLawLink:'',
                notifications:0,
                lastContest:null,
                currentType:'',
                target: null
            }
        },
        computed: {
            ...mapGetters([
                'getSideChallenges',
                'getGeneral',
                'getChallengeList',
                'getChallengeSelected',
              'getIsMobile'
            ]),

        },
        async created (){
            this.content = this.getSideChallenges;
            this.general = this.getGeneral;
            this.isMobile = this.getIsMobile;
            this.optionsDefault = this.general.challengesListConcoursDefault;
            this.currentType = ApiAuthenticationService.getCurrentUser().type;
            //GET LIST OF CONTESTS
            let promises = [];
            promises.push(ApiService.getConcoursApi().get().then((data) => {
                this.lists = data.data;
                //MAP INFO TO SELECT OPTIONS
                this.lists.map(element => {this.options.push(element.title)});
            }));
            //ACTIVE LAST CONTEST
            promises.push(ApiService.getConcoursApi().getCards(ApiAuthenticationService.getCurrentUser().id,1).then((data) => {
                if(data.data.length > 0){
                    this.lastContest = data.data[0];
                    this.$store.dispatch('setChallengeSelected',this.lastContest.id);
                    this.optionsDefault = this.lastContest.title;
                    this.getData();
                } else {
                    this.lastContest = null;
                    this.$store.dispatch('setChallengeSelected',null);
                }
            }));
            await Promise.all(promises);
        },
        methods: {
            displayToKey ($e){
                if($e!= this.optionsDefault){
                    let selectedId = this.lists.find(element => element.title == $e);
                    if(selectedId){
                      this.$store.dispatch('setChallengeSelected',selectedId.id);
                      this.optionsDefault = selectedId.title;
                    }
                }
            },

            async getData(){
                //this.$emit('showloader',true);
                if (this.getChallengeSelected){
                    this.notifications = 0;
                    let promises = [];
                    promises.push(ApiService.getConcoursApi().getReglement(this.getChallengeSelected,ApiAuthenticationService.getCurrentUser().type).then((data) => {
                        this.theLawId = data.data;
                        this.theLawLink = ApiService.getMediaApi().get(this.theLawId);
                    }, () => {
                        this.theLawId = null;
                        this.theLawLink = null;
                    }));
                    promises.push(ApiService.getConcoursApi().getResume(ApiAuthenticationService.getCurrentUser().id,this.getChallengeSelected).then((data) => {
                        this.target = data.data.target;
                        console.log(data.data);
                        this.notifications = data.data.currentExcursionNumber?.length || 0;
                    }));
                    await Promise.all(promises);
                }
                //this.$emit('showloader',true);
            },

            openAllChallenges(){
                this.$router.push({ name: 'mobile-challenges-all'}).catch(()=>{})
                this.isMobile ? setTimeout(()=> {
                    this.$store.dispatch('showHeader',false);
                    this.$store.dispatch('showFooter',false);
                },25) :'';
            },
            onItemClick(target) {
                target != undefined ? this.$router.push({ name: 'mobile', params: { subcat: target }}).catch(()=>{}) : this.$router.push({ name: 'challengesHome'}).catch(()=>{});
                this.isMobile ? setTimeout(()=> {
                    this.$store.dispatch('showHeader',false);
                    this.$store.dispatch('showFooter',false);
                    },50) :'';
            },
            openReglementModal(){
                if(this.isMobile){
                    this.$router.push({ name: 'mobile-challenges-all'});
                } else {
                    this.$root.$emit('bv::show::modal', 'reglements-modal', '#btnShow');
                }
            }

        },
        watch : {
            'getChallengeSelected' : function (){
                this.getData();
            },
          getIsMobile(){
              this.isMobile = this.getIsMobile;
          }
        },
    }
</script>
